
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { ReelCellContainer } from "./ReelCellContainer";

export class ReelCellComponent extends AbstractDisplayComponent {
    private reelCellContainer: ReelCellContainer;

    public override init() {
        let containerConfig = {
            labelName: "reelCell_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: -476,
                posY: -268,
                scale: 1,
            },
            portrait: {
                posX: -479,
                posY: -272,
                scale: 1,
            }
        };

        this.reelCellContainer = new ReelCellContainer(containerConfig);
    }

    public getInstance(): ReelCellContainer {
        return this.reelCellContainer;
    }

    public override destroy(): void {
        this.reelCellContainer.destroy(true);
    }
}
